import { LANGUAGE } from "@/common/utils/constants.js";

export const HOME_PPT = {
	[LANGUAGE.en.short]: {
		title1: `Home Section - slide 1`,
		titleSuccessStory: `Client Success Story`,
		projectId: `Project id`,
		industryId: `Industry id`
	},
	[LANGUAGE.de.short]: {
		title1: `Home-Bereich – Folie 1`,
		titleSuccessStory: `Kundenerfolgsgeschichte`,
		projectId: `Projekt-ID`,
		industryId: `Branchen-ID`
	},
	[LANGUAGE.fr.short]: {
		title1: `Section d'accueil - diapositive 1`,
		titleSuccessStory: `Témoignage de réussite d'un client`,
		projectId: `Identifiant du projet`,
		industryId: `Identifiant de l'industrie`
	},
	[LANGUAGE.it.short]: {
		title1: `Sezione Home - diapositiva 1`,
		titleSuccessStory: `Storia di successo del cliente`,
		projectId: `ID progetto`,
		industryId: `Identificazione del settore`
	},
	[LANGUAGE.ja.short]: {
		title1: `ホーム - スライド 1`,
		titleSuccessStory: `クライアントの成功事例`,
		projectId: `プロジェクトID`,
		industryId: `業界ID`
	},
	[LANGUAGE.es.short]: {
		title1: `Sección de inicio - diapositiva 1`,
		titleSuccessStory: `Historia de éxito del cliente`,
		projectId: `ID del proyecto`,
		industryId: `ID de la industria`
	},
}
